import React from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Modal,
  Col,
  Label,
} from "reactstrap";
import Select from "react-select";
import type { EditableUser } from "./DisplayUsers/UsersListContainer";

/** One choice of the role select. */
export type RoleOption = { value: string; label: string };

export type EditRoleViewProps = {
  formModal: boolean;
  toggleModal: () => void;
  user?: EditableUser;
  currentRoleLabel: string;
  onSelectRole: (option: RoleOption | null) => void;
  onSave: () => void;
};

const selectRoleData: RoleOption[] = [
  { value: "CONTENTEDITOR", label: "Content Editor" },
  { value: "SALESMANAGER", label: "Sales Manager" },
  { value: "CONTENTDIRECTOR", label: "Content Director" },
  { value: "CONTENTCOORDINATOR", label: "Content Coordinator" },
  { value: "ADMINISTRATOR", label: "Administrator" },
];

const EditRoleView = ({
  formModal,
  toggleModal,
  user,
  currentRoleLabel,
  onSelectRole,
  onSave,
}: EditRoleViewProps) => {
  return (
    <Modal
      className="modal-dialog-centered"
      size="sm"
      isOpen={formModal}
      toggle={toggleModal}
    >
      <div className="modal-body p-0">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent">
            <h3 className="mb-0 text-primary text-center">
              Update {user?.name ? ` ${user.name} ` : " user "}role
            </h3>
          </CardHeader>

          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>The user current permission role is </small>
              <strong className="text-primary">{currentRoleLabel}</strong>
            </div>

            <Form role="form" onSubmit={(e) => e.preventDefault()}>
              <Label className="form-control-label">Select permission role :</Label>
              <FormGroup className="row">
                <Col md="12">
                  <Select
                    value={selectRoleData.find(o => o.value === user?.role) || null}
                    name="role"
                    options={selectRoleData}
                    onChange={onSelectRole}
                    isClearable
                    isSearchable
                  />
                </Col>
              </FormGroup>

              <div className="text-center">
                <Button className="my-4" color="primary" type="button" onClick={onSave}>
                  Save changes
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </div>
    </Modal>
  );
};

export default EditRoleView;
